const env = import.meta.env;

export const apiProjectKey = env.VITE_API_PROJECT_KEY;
export const apiKey = env.VITE_API_KEY;

export const staticImageUrl = "https://img0.oastatic.com/img2/";
export const apiUrl = `https://www.outdooractive.com/api/project/${apiProjectKey}/`;
export const apiDownloadUrlGpx = `https://www.outdooractive.com/download.tour.gpx?project=${apiProjectKey}`;
export const apiDownloadUrlKml = `https://www.outdooractive.com/kml_generate?project=${apiProjectKey}`;

export { default as activities } from "./activities-mapping.json";
